import { CircularProgress, Box } from '@mui/material';

export default function Spinner() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress size={48} thickness={4} />
    </Box>
  );
}
